import { useState } from "react";
import {
  useItemFinalizeListener,
  useItemErrorListener,
  useItemStartListener,
  useAbortItem,
  FILE_STATES,
  BatchItem,
} from "@rpldy/uploady";
import UploadItemProgress from "./UploadItemProgress";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faTriangleExclamation,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { Button } from "@progress/kendo-react-buttons";
import { useAppSelector } from "hooks/redux";
import { selectAppConfig } from "store/appConfigSlice";

interface IUploadItemProps {
  item: BatchItem;
}

const MAX_FILE_SIZE = 26214400;

const UploadItem = (props: IUploadItemProps) => {

  const appConfig = useAppSelector(selectAppConfig);
  
  const [itemState, setState] = useState(props.item.state);
  const [errorResponse, setErrorResponse] = useState("");
  const abortItem = useAbortItem();

  useItemFinalizeListener((item: BatchItem) => {
    setState(item.state);
  }, props.item.id);

  useItemErrorListener((item: BatchItem) => {
    console.log(`item ${item.id} failed - `, item.uploadResponse);
    setErrorResponse(item.uploadResponse?.data[0]?.error?.message);
    setState(item.state);
  }, props.item.id);

  const isAborted = itemState === FILE_STATES.ABORTED,
    isSuccess = itemState === FILE_STATES.FINISHED,
    isError = itemState === FILE_STATES.ERROR,
    isFinished = ![FILE_STATES.PENDING, FILE_STATES.UPLOADING].includes(
      itemState
    );

  const onAbortItem = () => {
    abortItem(props.item.id);
  };

  useItemStartListener((item) => {
    if (item.file.size > (appConfig.maxFileSize ?? MAX_FILE_SIZE) ) {
      setErrorResponse(`Maximum file size (${appConfig.maxFileSize ?? MAX_FILE_SIZE} bytes) exceeded.`);
      abortItem(item.id);
    }
});
  
  if (!props.item) return <></>;
  
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          margin: "10px 0",
          justifyContent: "flex-start",
        }}
      >
        {isAborted && (
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            style={{ color: "#ab1717", fontSize: "24px" }}
          />
        )}
        {isError && (
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            style={{ color: "#ab1717", fontSize: "24px" }}
          />
        )}
        {isSuccess && (
          <FontAwesomeIcon
            icon={faCheck}
            style={{ color: "#1f5122", fontSize: "24px" }}
          />
        )}
        {!isFinished && <UploadItemProgress id={props.item.id} />}
        <span style={{ display: "inline-block", margin: "0 10px" }}>
          {props?.item?.file?.name && props.item.file.name}
        </span>

        {!isFinished && (
          <Button
            fillMode={"flat"}
            onClick={onAbortItem}
            title={`Cancel ${props.item.file.name}  upload`}
          >
            <FontAwesomeIcon
              icon={faXmark}
              style={{ color: "#890606", fontSize: "24px" }}
            />
          </Button>
        )}
      </div>

      {errorResponse && (
        <span
          style={{ color: "#890606" }}
        >{`Error uploading ${props.item.file.name} - ${errorResponse}`}</span>
      )}
    </>
  );
};

export default UploadItem;
